export enum PaymentMethod {
  Cash = 1,
  Card = 2,
  Online = 4,
  RedSys = 8,
  Stripe = 16,
  MetroBank = 32,
  CyberSource = 64,
  QR = 128,
  Invitation = 256,
  Employee = 512,
  BankTransfer = 1024,
  CustomerAccount = 2048,
  Club = 4096,
}
